webpackJsonp([67329340664633],{

/***/ 1634:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/people/paula-hayes/","posts":[{"fields":{"slug":"/news/10-questions-with-paula-hayes/","author":{"id":"/opt/build/repo/src/pages/people/paula-hayes.md absPath of file >>> MarkdownRemark"}},"frontmatter":{"title":"10 Questions with Paula Hayes","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 10 questions article header image paula hayes-0f68e838281ee3177cb0bbe793bce5ee.jpg"}}},"original":"/img/1160x450 10 questions article header image paula hayes.jpg"},"category":"Culture"}}]},"frontmatter":{"title":"Paula Hayes"}}}]}},"pathContext":{"author":"/people/paula-hayes/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-paula-hayes-acf0f10e44391f0697a9.js